import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Event, EventProps } from '..';
import { classes } from './Event.visual.st.css';
import { VisualAsync } from '../../test/visual/VisualAsync';
import { eventDriverFactory } from './Event.driver';

const defaultProps: EventProps = {
  title: 'Calendar Lunch',
};

visualize('Event', () => {
  story('render', () => {
    snap('default', <Event {...defaultProps} />);
    snap(
      'default with background override',
      <Event
        onClick={() => {}}
        className={classes.backgroundOverride}
        {...defaultProps}
      />,
    );
    snap('time', <Event time="23:23" {...defaultProps} />);
    snap('timeShown', <Event showTime {...defaultProps} />);
    snap('fullday', <Event fullday {...defaultProps} />);
    snap(
      'fullday with background override',
      <Event
        onClick={() => {}}
        {...defaultProps}
        fullday
        className={classes.fulldayBackgroundOverride}
      />,
    );
    snap('selected', <Event selected {...defaultProps} />);
    snap(
      'selected with background override',
      <Event
        onClick={() => {}}
        {...defaultProps}
        selected
        className={classes.selectedOverlayBackgroundOverride}
      />,
    );
    snap('clickable', <Event onClick={() => {}} {...defaultProps} />);
    snap('disabled', <Event onClick={() => {}} disabled {...defaultProps} />);
    snap(
      'with text style overrides',
      <Event
        onClick={() => {}}
        {...defaultProps}
        time="23:23"
        className={classes.textStyleOverrides}
      />,
    );
  });

  story('focus', () => {
    const focusTests = [
      { it: 'clickable', props: { ...defaultProps, onClick: () => {} } },
      {
        it: 'clickable disabled',
        props: { ...defaultProps, disabled: true, onClick: () => {} },
      },
      {
        it: 'not clickable',
        props: { ...defaultProps, disabled: false, onClick: null },
      },
    ];
    focusTests.forEach(({ it, props }) => {
      snap(it, (done) => (
        <VisualAsync
          driverFactory={eventDriverFactory}
          onDone={done}
          action={(driver) => driver.click()}
        >
          <Event {...props} />
        </VisualAsync>
      ));
    });
  });
});
